/**
 * 将文本分割成单词
 * @param {string} text - 原始文本
 * @returns {Array} - 单词数组
 */
function splitWords(text) {
    return text.split('_');
}

/**
 * 将切割字符串分割成片段
 * @param {string} cut - 切割字符串
 * @returns {Array} - 片段数组
 */
function splitSegments(cut) {
    return cut.split('/').filter(Boolean);
}

/**
 * 计算每个片段对应的纯文本
 * @param {string} segment - 带颜色标记的片段
 * @returns {string} - 纯文本
 */
function getPlainText(segment) {
    return segment.replace(/[红蓝黑]/g, '');
}

/**
 * 处理单个数据项
 * @param {Object} item - 数据项
 * @returns {Object} - 处理后的数据项
 */
function processItem(item) {
    const words = splitWords(item.text);
    const segments = splitSegments(item.cut);

    let currentWord = '';
    let currentWordIndex = 0;
    let newCut = [];

    for (let segment of segments) {
        const plainText = getPlainText(segment);
        currentWord += plainText;

        newCut.push(segment);

        // 检查当前累积的文本是否匹配完整单词
        if (currentWord === words[currentWordIndex]) {
            // 如果不是最后一个单词，添加下划线
            if (currentWordIndex < words.length - 1) {
                newCut.push('_');
            }
            currentWord = '';
            currentWordIndex++;
        }
    }

    return {
        ...item,
        cut: newCut.join('/')
    };
}

/**
 * 处理数据数组
 * @param {Array} data - 输入数据数组
 * @returns {Array} - 处理后的数据数组
 */
export function processData(data) {
    return data.map(processItem);
}

